import { Component } from '@angular/core';

@Component({
    selector: 'ifb-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent {

  constructor() { }

}
